
( function($) {
    $(document).ready(function () {
        galleryCarousel();
    });

    function fixFancyboxSlick(innerElem) {
        // Fix for mini gallery fancy box
        var selector = '.slick-slide:not(.slick-cloned)';
        if(innerElem){
            selector = selector+' '+innerElem;
        }
        // Skip cloned elements
        $().fancybox({
            selector: selector,
            backFocus: false,
            loop: true

        });
        // Remove fancybox cloned elements
            if(innerElem){
                $('.slick-cloned '+innerElem).each( function () {
                    $(this).removeAttr('data-fancybox');
                });

            }else {
                $('.slick-cloned .thumb').removeAttr('data-fancybox');
            }


        // Attach custom click event on cloned elements,
        // trigger click event on corresponding link
        var clonedElement = '.slick-cloned';
        if(innerElem){
            clonedElement = '.slick-cloned '+innerElem;
        }
        $(document).on('click', clonedElement, function (e) {
            $(selector)
                .eq(( $(e.currentTarget).attr("data-slick-index") || 0) % $(selector).length)
                .trigger("click.fb-start", {
                    $trigger: $(this)
                });

            return false;
        });
    }

    function galleryCarousel() {
        var wrapper = $('.gallery_section.carousel');
        wrapper.each(function () {
            var current = $(this);
            var wrap = current.find('.slider_inner_wrap'),
            children = wrap.find('.thumb_wrap'),
            hasCarousel = false;
            if(is_phone && children.length > 1){
                hasCarousel = true;
            } else if (is_mobile && children.length > 2){
                hasCarousel = true;
            } else {
                if(children.length > 3){
                    hasCarousel = true;
                }
            }

            if (wrap.length > 0) {
                if(hasCarousel){
                    wrap.on("init", function () {
                        lazyLoadInstance.update();
                    });

                    wrap.slick({
                        rows: 0,
                        infinite: true,
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        swipeToSlide: false,
                        touchMove: false,
                        arrows: true,
                        dots: true,
                        prevArrow: accor_arrow_prev,
                        nextArrow: accor_arrow_next,
                        centerMode:true,
                        centerPadding: '140px',
                        rtl: $('html').attr('dir') === 'rtl',
                        customPaging: function(slider, i) {
                            return $('<button type="button" />');
                        },
                        responsive: [
                            {
                                breakpoint: 1799,
                                settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 3,
                                    centerPadding: '140px',
                                }
                            },
                            {
                                breakpoint: 1199,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 2,
                                    centerPadding: '70px',
                                }
                            },
                            {
                                breakpoint: 767,
                                settings: {
                                    arrows:true,
                                    dots: false,
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    centerPadding: '20px'
                                }
                            },
                        ]
                    });
                }

                fixFancyboxSlick('.thumb_content .description');
                wrap.trigger('builder_gallery_ready');
            }
        });
    }

} ( jQuery ) );
